
import { defineComponent, onMounted } from 'vue';
import CustomerPaymentList from '../components/CustomerPaymentList.vue';
import { setPageHeader } from '@/core/helpers/toolbar';

export default defineComponent({
    name: 'CustomerPayment',
    components: {
        CustomerPaymentList
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.CUSTOMERS_PAYMENT_REPORT',
                actionButton: {
                    ability: '',
                    pageAction: {
                        action: ''
                    },
                    button: {}
                },
                breadCrumbs: [{ name: 'message.HOME', link: '/dashboard' }, { name: 'message.REPORTS', link: '#' }, { name: 'message.CUSTOMERS_PAYMENT_REPORT' }]
            });
        });
    }
});
